import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  IconButton,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import axios from "axios";
import { formatDate } from "../CommonFunctions";
import { getVacantRoomsByDate } from "../TenancyApi";

export default function ChangeRoomForm({
  open,
  onClose,
  tenancyDetails,
  handleChangeRoom
}) {
  const [selectedRoom, setSelectedRoom] = useState("");
  const [availableRooms, setAvailableRooms] = useState([]);
  const [loading, setLoading] = useState(false);

  const url = process.env.REACT_APP_SERVER_URL;

  // Fetch available rooms when dialog opens
  useEffect(() => {
    if (open) {
      loadAvailableRooms();
      setSelectedRoom("");
    }
  }, [open]);

  const loadAvailableRooms = async () => {
    try {
      setLoading(true);
      const response = await getVacantRoomsByDate(formatDate(new Date()), tenancyDetails.checkout);
      if(response){
        console.log(response);
        setAvailableRooms(response);
      }

    } catch (error) {
      console.log("Error loading rooms", error);
      setAvailableRooms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = () => {
    if (!selectedRoom) return;
    handleChangeRoom(selectedRoom);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Change Room
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* Current details */}
        <Box mb={2}>
          <Typography><b>Current Room:</b> {tenancyDetails.roomid}</Typography>

          <Typography>
            <b>Stay Duration:</b>{" "}
            {tenancyDetails.checkin &&
              format(new Date(tenancyDetails.checkin), "MMM dd, yyyy")}{" "}
            to{" "}
            {tenancyDetails.checkout &&
              format(new Date(tenancyDetails.checkout), "MMM dd, yyyy")}
          </Typography>

          <Typography mt={1} fontSize="0.9rem" color="text.secondary">
            Select a new room to move this guest.
          </Typography>
        </Box>

        {/* Loading state */}
        {loading && (
          <Box display="flex" justifyContent="center" py={2}>
            <CircularProgress size={26} />
          </Box>
        )}

        {/* Available Rooms Dropdown */}
        {!loading && (
          <FormControl fullWidth size="small">
            <InputLabel>Available Rooms</InputLabel>
            <Select
              label="Available Rooms"
              value={selectedRoom}
              onChange={(e) => setSelectedRoom(e.target.value)}
            >
              {availableRooms.length === 0 && (
                <MenuItem value="" disabled>
                  No rooms available
                </MenuItem>
              )}

              {availableRooms.map((room) => (
                <MenuItem key={room.id} value={room.id}>
                  Room {room.id} — {room.type || "Standard"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!selectedRoom || loading}
          sx={{ textTransform: "none", px: 3 }}
        >
          Confirm Change
        </Button>
      </DialogActions>
    </Dialog>
  );
}
